

export class RMInvoicePrintReq {
    invoiceNumber?: string;


    constructor(

        invoiceNumber?:string,
        ){
      this.invoiceNumber = invoiceNumber;

    }
  }